import { render, staticRenderFns } from "./HeaderPoint.vue?vue&type=template&id=394b9430&scoped=true"
import script from "./HeaderPoint.vue?vue&type=script&lang=ts"
export * from "./HeaderPoint.vue?vue&type=script&lang=ts"
import style0 from "./HeaderPoint.vue?vue&type=style&index=0&id=394b9430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b9430",
  null
  
)

export default component.exports